import { relativeSortColumnsWithHide } from 'module/helpers/column-order';
import {
  FilterableField,
  //NoteField,
} from 'module/types/filter-field/field/filterable-field';
//import { useWithAccess } from 'hooks/rbac/useWithAccess';
import {
  ColumnOrder,
  GridChangeEvent,
} from 'module/ui/components/molecules/ag-grid-renderer/grid-column';
import { debounce, keyBy } from 'lodash';
import { pipe } from 'ramda';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGridOptions } from 'components/organisms/accounts/lists/gridconfig/useGridOptions';
import {
  getColDef,
  withCustomerNameClickHandler,
  withOnUpdate,
  //withCustomerNameClickHandler,
  //withNoteFieldProperty,
} from './columns';
//import { CustomerCompanyListFilter } from './url-params/types';
import { DEFAULT_FIELD_LIST, useColumnOrder } from './use-column-order';
import { useGridUpdater } from './use-grid-updater';
import { useServerSideData } from './use-server-side-data';
import type {
  ColumnState,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ColDef,
} from 'ag-grid-community';

interface Props {
  fields: FilterableField[];
  isFieldsLoading: boolean;
  customerNameClickHandler: (data) => void;
  //openNoteForField: (field: NoteField, data) => void;
  //filter: CustomerCompanyListFilter;
  searchText: string;
}

export const relativelySortByDefaultColumnOrder = (
  colDefs: ColDef[],
): ColDef[] => {
  const newColumnOrder = DEFAULT_FIELD_LIST.map((x) => [x, false]);

  return relativeSortColumnsWithHide(colDefs, newColumnOrder);
};
interface Result {
  gridApi?: GridApi;
  gridOptions: GridOptions;
  onGridReady: (event: GridReadyEvent) => void;
  currentColumnOrder: ColumnOrder[];
  defaultColumnOrder: ColumnOrder[];
  changeCurrentColumnOrder: (next: ColumnOrder[]) => void;
  changeColumnOrderFromState: (next: ColumnState[]) => void;
}
export const useGridConfiguration = ({
  fields,
  isFieldsLoading,
  customerNameClickHandler,
  //openNoteForField,
  //filter,
  searchText,
}: Props): Result => {
  const fieldsLookup = useMemo(() => keyBy(fields, 'fieldName'), [fields]);
  const [gridApi, setGridApi] = useState<GridApi | undefined>(undefined);
  const { updateCustomerCompany } = useGridUpdater({
    gridApi,
  });
  // const { hasAccessToResource } = useWithAccess();
  /* const checkWriteAccess = useCallback(
    (field) => {
      return hasAccessToResource({
        rule:
          field.fieldDataType === 'NOTE'
            ? 'NOTE:WRITE'
            : 'CUSTOMER_COMPANY_FIELD:WRITE',
      });
    },
    [hasAccessToResource],
  );*/
  const toColumnDefs = useMemo(
    () =>
      pipe(
        getColDef(),
        withCustomerNameClickHandler(customerNameClickHandler),
        // withNoteFieldProperty(fieldsLookup, openNoteForField),
        relativelySortByDefaultColumnOrder,
        withOnUpdate(updateCustomerCompany),
      ),
    [
      customerNameClickHandler,
      //fieldsLookup,
      //openNoteForField,
      updateCustomerCompany,
    ],
  );
  const {
    currentColumnOrder,
    defaultColumnOrder,
    changeColumnOrderFromState,
    changeCurrentColumnOrder,
  } = useColumnOrder({
    fields,
    isFieldsLoading,
    toColumnDefs,
    gridApi,
  });

  const handleGridChange = useCallback(
    (event: GridChangeEvent) => {
      if (event) {
        changeColumnOrderFromState(event.api.getColumnState());
      }
    },
    [changeColumnOrderFromState],
  );
  const throttledGridChange = useMemo(
    () => debounce(handleGridChange, 100),
    [handleGridChange],
  );

  useEffect(() => {
    //fields.length);
    if (!gridApi || !fields.length) {
      return;
    }

    //console.log('toColumnDefs', toColumnDefs(fields));

    gridApi?.setGridOption('columnDefs', toColumnDefs(fields));
  }, [gridApi, toColumnDefs, fields]);

  const setupServerSideDataSource = useServerSideData({
    fieldsLookupByName: fieldsLookup,
    // filter,
    gridApi,
    searchText,
  });
  const onGridReady = useCallback(
    (event: GridReadyEvent) => {
      setGridApi(event.api);
      setupServerSideDataSource(event);
    },
    [setupServerSideDataSource],
  );

  const gridOptions = useGridOptions(throttledGridChange);

  return {
    gridApi,
    gridOptions,
    onGridReady,
    currentColumnOrder,
    defaultColumnOrder,
    changeColumnOrderFromState,
    changeCurrentColumnOrder,
  };
};
